import { InformativeModal } from "../../../components/modal/Modal.tsx";
import { useTranslation } from "../../../state/i18n.tsx";

const DeleteTaskExistingSubmissionsModal = () => {
  const { t } = useTranslation();

  return (
    <InformativeModal
      title={t(($) => $.DELETE_TASK_EXISTING_SUBMISSIONS_MODAL_TITLE)}
      description={t(($) => $.DELETE_TASK_EXISTING_SUBMISSIONS_MODAL_DESCRIPTION)}
      confirmLabel={t(($) => $.DELETE_TASK_EXISTING_SUBMISSIONS_MODAL_ACTIONS_CONFIRM)}
      closeAriaLabel={t(($) => $.CLOSE_ARIA)}
    />
  );
};

export default DeleteTaskExistingSubmissionsModal;
